import AnalyticsIdentityAudienceInsights from './AudienceInsights'
export default AnalyticsIdentityAudienceInsights
